import React, { Component } from 'react';
import Analytics from "./index";

export default function withTracker(WrappedComponent, options = {}) {
  const trackPage = (page) => {
    Analytics.trackPageView(page, options);
  };

  const HOC = class extends Component {
    componentDidMount() {
      const page = this.props.location.pathname + this.props.location.search;
      trackPage(page);
    }

    componentWillReceiveProps(nextProps) {
      const currentPage = this.props.location.pathname + this.props.location.search;
      const nextPage = nextProps.location.pathname + nextProps.location.search;

      if (currentPage !== nextPage) {
        trackPage(nextPage);
      }
    }

    render() {
      return <WrappedComponent {...this.props} />;
    }
  };

  return HOC;
}
